/** Where an answer places an email, on its own line: its 1-based position in the
 * message's drafts, or (before the worker numbers it) a draft id. Mirrors
 * drafts.EMAIL_MARKER_RE; the one copy every page reads. */
export const EMAIL_MARKER = /^\s*\{\{email:(\d+|d-[0-9a-f]{12})\}\}\s*$/gm;

/** A question the specialist raised with ask_operator, placed in its answer by alert
 * id. Mirrors drafts.DECISION_MARKER_RE. */
export const DECISION_MARKER = /^\s*\{\{decision:(alert-[0-9a-f]{32})\}\}\s*$/gm;

/** Either marker, for an answer that places both: split() yields prose, then the
 * marker's kind and key, in threes. */
export const ANSWER_MARKER =
  /^\s*\{\{(email|decision):(\d+|d-[0-9a-f]{12}|alert-[0-9a-f]{32})\}\}\s*$/gm;
